export default __webpack_public_path__ + "static/media/battery-5-light.da06fc21.svg";